<template>
  <div style="text-align: center;">
    <h5>查询情况--证明系统</h5>
    <h6>已下载：{{ downloadedCount }}人，未下载：{{ notDownloadedCount }}人，共计：{{ students.length }}人</h6>
    <!-- 学期选择框 -->
    <el-select v-model="selectedSemester" placeholder="请选择学期" style="width: 200px; margin-bottom: 20px;" @change="updateSelectedSemesterName">
      <el-option
        v-for="(item, index) in semesters"
        :key="item.uuid"
        :label="item.name"
        :value="item.uuid">
        <span>{{ item.name }}</span>
        <template v-if="index === 0">
          <el-tag type="primary" style="margin-left: 10px;">当前学期</el-tag>
        </template>
      </el-option>
    </el-select>
    <!-- 查询按钮 -->
    <el-button type="primary" @click="fetchStudents">查询</el-button>
    <!-- 导出按钮 -->
    <el-button type="success" @click="exportToExcel">导出为 Excel</el-button>
    <!-- 统计信息 -->
    <el-table :data="students" style="width: 100%; margin-top: 20px;">
      <el-table-column prop="uuid" label="uuid"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="type" label="类型" :formatter="formatType"></el-table-column>
      <el-table-column label="学期">
        <template #default>
          {{ selectedSemesterName }}
        </template>
      </el-table-column>
      <el-table-column prop="data_type" label="角色类型"></el-table-column>
      <el-table-column prop="find_number" label="下载次数" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage } from 'element-plus';

export default {
  data() {
    return {
      students: [],
      semesters: [],
      selectedSemester: null,
      selectedSemesterName: '', // 用于显示在表格中的学期名称
      downloadedCount: 0,
      notDownloadedCount: 0,
    };
  },
  mounted() {
    this.fetchSemesters();
  },
  methods: {
    async fetchSemesters() {
      try {
        const response = await axios.get('/api/semesters');
        this.semesters = response.data.semesters;
      } catch (error) {
        ElMessage({
          type: 'error',
          message: '获取学期数据失败',
        });
      }
    },
    async fetchStudents() {
      if (!this.selectedSemester) {
        ElMessage({
          type: 'warning',
          message: '请选择一个学期',
        });
        return;
      }
      try {
        const response = await axios.get(`/api/find_teachers?semesterUuid=${this.selectedSemester}`);
        this.students = response.data;
        this.updateCounts(); // 更新统计信息
      } catch (error) {
        ElMessage({
          type: 'error',
          message: '获取课程数据失败',
        });
      }
    },
    updateSelectedSemesterName() {
      const selectedSemesterObj = this.semesters.find(semester => semester.uuid === this.selectedSemester);
      this.selectedSemesterName = selectedSemesterObj ? selectedSemesterObj.name : '';
    },
    updateCounts() {
      this.downloadedCount = this.students.filter(student => student.find_number > 0).length;
      this.notDownloadedCount = this.students.length - this.downloadedCount;
    },
    async exportToExcel() {
      if (!this.selectedSemester) {
        ElMessage({
          type: 'warning',
          message: '请选择一个学期',
        });
        return;
      }
      try {
        const response = await axios.get(`/api/export_excel?semesterUuid=${this.selectedSemester}`, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '教师查询情况数据下载.xlsx');
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        ElMessage({
          type: 'error',
          message: '导出 Excel 失败',
        });
      }
    },
    formatType(row) {
      const typeMap = {
        School_Course_Summary: "开课",
        School_Lecture: "讲座",
        School_Preparation_Summary: "主备",
        Internship_Certificate: "跟岗",
      };
      return typeMap[row.type] || row.type; // 如果没有匹配项，返回原始值
    },
  }
};
</script>
